import type {
  IPostTrainingAppliesCandidateCreateOfferBody,
  IPostTrainingAppliesCandidateExistingOfferBody,
  TManualTrainingApplyOffer,
  TTrainingApplyOffer,
  TTrainingApplyOfferCreation,
} from "@api";
import { formatTrainingSharedFormToOffer } from "../../sharedForm/format";
import type { IModalTrainingApplyForm } from "../types";
import type { TModalTrainingApplyFormResolver } from "./resolver";

export const formatTrainingApplyFormToOffer = (
  data: IModalTrainingApplyForm,
  documents: string[]
): TTrainingApplyOfferCreation => {
  const {
    status: _status,
    createAssociatedOffer: _createAssociatedOffer,
    documents: _existingDocuments,
    ...sharedData
  } = data;

  return {
    ...formatTrainingSharedFormToOffer(sharedData),
    documents,
  };
};

export const formatTrainingApplyFormToManualOffer = (
  data: IModalTrainingApplyForm,
  documents: string[]
): TManualTrainingApplyOffer => {
  const now = new Date();

  return {
    ...formatTrainingApplyFormToOffer(data, documents),
    active: true,
    isExpired: false,
    offerId: "",
    publicationDate: now,
    publicationUpdatedDate: now,
    source: "BimBamJob",
  };
};

export const formatTrainingApplyPayload = (
  data: TModalTrainingApplyFormResolver,
  offer: TTrainingApplyOffer
): IPostTrainingAppliesCandidateExistingOfferBody => {
  return {
    status: data.status,
    offer,
  };
};

export const formatTrainingApplyPayloadWithOfferCreation = (
  data: TModalTrainingApplyFormResolver,
  offer: TTrainingApplyOfferCreation
): IPostTrainingAppliesCandidateCreateOfferBody => {
  return {
    status: data.status,
    offer,
    createAssociatedOffer: true,
  };
};
